import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import classnames from 'classnames';
import { useProtocolStore } from 'lib/store/protocol';
import { rem } from 'lib/utils/util';
import { report } from 'lib/utils/dataReport';
import { ATTA_GATEWAY_MOBILE } from 'lib/constants/atta';
import './index.scss';

interface ProtocolProps {
  fontSize?: number;
  expandTextColor?: string;
  checkboxBorderColor?: string;
}

export default function Protocol({ fontSize, expandTextColor, checkboxBorderColor = '#fff' }: ProtocolProps) {
  const protocolShortText = useProtocolStore((state) => state.protocolShortText);
  const isCheckedProtocol = useProtocolStore((state) => state.isCheckedProtocol);
  const setIsCheckedProtocol = useProtocolStore((state) => state.setIsCheckedProtocol);
  const showProtocolDialog = useProtocolStore((state) => state.showProtocolDialog);

  const handleCheckboxChange = () => {
    report(ATTA_GATEWAY_MOBILE.AGREEMENT_TOGGLE);
    setIsCheckedProtocol(!isCheckedProtocol);
  };

  const handleExpandClick = () => {
    showProtocolDialog({
      buttonText: '关闭',
    });
  };

  // 最后新增点击展开文案
  const protoclPureHtml = useMemo(() => {
    const purifyConfig = {
      ADD_ATTR: ['target'],
    };
    return DOMPurify.sanitize(
      `${protocolShortText}<p class="protocol-checkbox__expand-text" style="${
        expandTextColor ? `color:${expandTextColor};` : ''
      }">点击展开</p>`,
      purifyConfig,
    );
  }, [protocolShortText, expandTextColor]);

  return (
    <div className="protocol-checkbox__label">
      <div
        className={classnames('protocol-checkbox__input', {
          'protocol-checked': isCheckedProtocol,
        })}
        onClick={handleCheckboxChange}
        style={{ borderColor: checkboxBorderColor }}
      />
      <div className="protocol-checkbox__text-container" style={fontSize ? { fontSize: rem(fontSize) } : {}}>
        <div
          className="protocol-checkbox__text"
          dangerouslySetInnerHTML={{
            __html: protoclPureHtml,
          }}
          onClick={(e) => {
            if (!(e.target as HTMLElement).classList.contains('protocol-checkbox__expand-text')) return;
            handleExpandClick();
          }}
        />
      </div>
    </div>
  );
}
